import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import init from "Helpers/WindowToken";
import axios from "axios";
import Constants from "Helpers/Constants";

function Dashboard() {
  let user = {};
  if (localStorage.getItem("admin_details")) {
    try {
      user = JSON.parse(localStorage.getItem("admin_details"));
    } catch (e) {
      console.error("Failed to parse admin_details:", e);
    }
  }

  const [data, setData] = useState({});
  const [notification, setNotification] = useState(false);
  const [notiColor, setNotiColor] = useState("success");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const adminDetails = localStorage.getItem("admin_details");

    if (adminDetails) {
      try {
        const parsedDetails = JSON.parse(adminDetails);

        if (parsedDetails?.role === "superadmin") {
          getSuperAdminData();
        } else {
          getEmployeeDashData();
        }
      } catch (error) {
        console.error("Error parsing admin_details:", error);
      }
    } else {
      console.warn("No admin details found in localStorage");
    }
  }, []);

  const handleError = () => {
    setNotification(true);
    setNotiColor("warning");
    setMessage("Something went wrong!");
    setTimeout(() => {
      setNotiColor("success");
      setNotification(false);
      setMessage("");
    }, 3000);
  };

  const getSuperAdminData = () => {
    if (init() === "success") {
      axios
        .get(Constants.getUrls.getAdminDasboard)
        .then((resp) => {
          // expected shape:
          // data: { blogCount, eventCount, courseCount, franchiseCount, schoolCount }
          setData(resp.data.data || {});
        })
        .catch((err) => {
          console.error(err);
          handleError();
        });
    }
  };

  const getEmployeeDashData = () => {
    if (init() === "success") {
      axios
        .get(Constants.getUrls.getDashboard)
        .then((resp) => {
          // expected shape:
          // data: { totalQuestions, uniqueSubjects, uniqueTopics, uniqueLevels }
          setData(resp.data.data || {});
        })
        .catch((err) => {
          console.error(err);
          handleError();
        });
    }
  };

  const isSuperAdmin = user?.role === "superadmin";

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {isSuperAdmin ? (
        // ---------------- SUPERADMIN DASHBOARD ----------------
        <MDBox py={3}>
          {/* <Grid container spacing={1}>
            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="dark"
                  icon="article"
                  title="Total Blogs"
                  count={data?.blogCount ?? 0}
                />
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="event"
                  title="Total Events"
                  count={data?.eventCount ?? 0}
                />
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="school"
                  title="Courses"
                  count={data?.courseCount ?? 0}
                />
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="primary"
                  icon="business_center"
                  title="Franchise Enquiry"
                  count={data?.franchiseCount ?? 0}
                />
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="info"
                  icon="account_balance"
                  title="School Enquiry"
                  count={data?.schoolCount ?? 0}
                />
              </MDBox>
            </Grid>
          </Grid> */}
        </MDBox>
      ) : (
        // ---------------- EMPLOYEE / NORMAL ADMIN DASHBOARD ----------------
        <MDBox py={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="dark"
                  icon="article"
                  title="Total Blogs"
                  count={data?.uniqueSubjects ?? 0}
                />
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="event"
                  title="Total Events"
                  count={data?.uniqueTopics ?? 0}
                />
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="school"
                  title="Total Courses"
                  count={data?.uniqueLevels ?? 0}
                />
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="primary"
                  icon="person_add"
                  title="School Enquiries"
                  count={data?.totalQuestions ?? 0}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      )}

      <MDSnackbar
        color={notiColor}
        icon="notifications"
        title="Dashboard"
        content={message}
        dateTime="Just now"
        open={notification}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
